import React from 'react';

import { Helmet, HelmetProvider } from 'react-helmet-async';

const meta = {
  title: '404 Not Found | Bagga International',
  meta: [
    { name: 'description', content: 'Sorry, the page you are looking for does not exist or has been moved.' },
    { property: 'og:title', content: '404 Not Found | Bagga International' },
    { property: 'og:description', content: 'Sorry, the page you are looking for does not exist or has been moved.' },
    { property: 'og:image', content: '/images/site-default-og.jpg' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://baggainternational.com/404' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: '404 Not Found | Bagga International' },
    { name: 'twitter:description', content: 'Sorry, the page you are looking for does not exist or has been moved.' },
    { name: 'twitter:image', content: '/images/site-default-og.jpg' }
  ],
  link: [
    { rel: 'canonical', href: 'https://baggainternational.com/404' }
  ],
  style: [],
  script: [],
};

export default function NotFound() {
  return (
    <>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <div className="container mx-auto px-4 py-8 text-center">
      <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
      <p className="text-lg text-coolGray-500 mb-6">Sorry, the page you are looking for does not exist or has been moved.</p>
      <a href="/" className="text-green-600 hover:underline">Go to Home</a>
    </div>
    </>
  );
}
